import type { SavedFilterStructure } from '@/Atomic/Organisms/FilterBuilder/types'

/**
 * Encodes a SavedFilterStructure into the `?query=` URL param used by the
 * structured filter channel.
 *
 * Copied from @/utils/filterQuery so the AiChatBot tools tree has no @/utils
 * app-internal import. Behaviour is byte-identical: padding stripped because
 * PISA rejects `=` characters in the query param.
 */
export const encodeFilterQuery = (structure: SavedFilterStructure): string =>
  btoa(JSON.stringify(structure)).replaceAll('=', '')

const isFilterStructure = (value: unknown): value is SavedFilterStructure =>
  typeof value === 'object' &&
  value !== null &&
  'or' in value &&
  Array.isArray(value.or)

/**
 * Decodes the `?query=` URL param back into a SavedFilterStructure. Copied from
 * @/utils/filterQuery so the tools tree has no @/utils import; behaviour is
 * byte-identical. Returns `undefined` for an absent, malformed, or non-filter payload.
 */
export const decodeFilterQuery = (
  query: string | null | undefined,
): SavedFilterStructure | undefined => {
  if (!query) return undefined
  try {
    // Re-pad — historic writers kept the `=` padding, current ones strip it.
    const padded = query.padEnd(Math.ceil(query.length / 4) * 4, '=')
    const parsed: unknown = JSON.parse(atob(padded))
    return isFilterStructure(parsed) ? parsed : undefined
  } catch {
    return undefined
  }
}
